import React from 'react';
import DraggableModal from 'chameleon/packages/blue-book-player/library/modal/DraggableModal';

function CalculatorModal(props) {
  const { onClose } = props;
  return (
    <DraggableModal title="Calculator" onClose={onClose}>
      CONTENT OF THE MODAL
    </DraggableModal>
  );
}

export default CalculatorModal;
